import React from "react";

interface LinkifiedTextProps {
  text: string;
  className?: string;
}

const LinkifiedText: React.FC<LinkifiedTextProps> = ({ text, className = "" }) => {
  // Regular expression to detect URLs, mailto links, and email addresses
  const urlRegex = /(https?:\/\/[^\s]+|mailto:[^\s<>]+|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
  
  const parts = text.split(urlRegex);
  
  return (
    <span className={className}>
      {parts.map((part, index) => {
        if (part.match(urlRegex)) {
          const isMailto = part.startsWith('mailto:');
          const isEmail = part.includes('@') && !part.startsWith('http') && !part.startsWith('mailto:');
          
          if (isMailto) {
            return (
              <a
                key={index}
                href={part}
                target="_self"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                {part.replace('mailto:', '')}
              </a>
            );
          } else if (isEmail) {
            return (
              <a
                key={index}
                href={`mailto:${part}`}
                target="_self"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                {part}
              </a>
            );
          } else {
            return (
              <a
                key={index}
                href={part}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                {part}
              </a>
            );
          }
        }
        return <React.Fragment key={index}>{part}</React.Fragment>;
      })}
    </span>
  );
};

export default LinkifiedText;
